import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function useProductGroup() {
  const api = useApi()
  const [dataProduct, setData] = useState<SelectOptionType[]>([])
  const [isLoadingProduct, setLoading] = useState(true)

  const refetchGroup = () => {
    setLoading(true)

    api.get("/productgroup/")
    .then((res: SuccessFetch<{
      payload: {
        mr_product_group_id: number
        mr_product_group_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.mr_product_group_name, value: item.mr_product_group_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    api.get("/productgroup/").then((res: SuccessFetch<{
      payload: {
        mr_product_group_id: number
        mr_product_group_name: string
      }[]
    }>) => {
      setData(res.data.payload.map(item => {
        return {
          label: item.mr_product_group_name,
          value: item.mr_product_group_id.toString()
        }
      }))
    }).catch(() => {
      setData([])
    }).finally(() => {
      setLoading(false)
    })
  
    return () => {
      setData([])
      setLoading(true)
    }

    // eslint-disable-next-line
  }, [])

  return { dataProduct, isLoadingProduct, refetchGroup }
}